import { compose, branch, renderComponent, withProps } from 'recompose'
import moment from 'moment'
import { connect } from 'react-redux'

import {
  withInitialData,
  subscriptionSelect
 } from '../components/hoc'
import PCMReflashingPage from '../components/PCMReflashing'
import PCMReflashingValidSubscription from '../components/PCMReflashing/WithValidSubscription'

const mapStateToProps = (state, ownProps) => {
  const products = state.products.list.length ? state.products.list : ownProps.products
  return {
    products: products.filter(item => item.product_type && item.product_type.key === 'PCM'),
    softwareLinksMap: state.global.softwareLinks.byType
  }
}

export default compose(
  connect(mapStateToProps, null),
  withProps({
    title: 'common:pcm',
    contentImage: ''
  }),
  withInitialData,
  subscriptionSelect,
  branch(
    ({ user }) => {
      if (user && user.reprog_exp_date) {
        const expDate = moment(user.reprog_exp_date)
        return moment().isBefore(expDate)
      }
    },
    renderComponent(PCMReflashingValidSubscription)
  )
)(PCMReflashingPage)




// WEBPACK FOOTER //
// ./pages/pcm-reflashing.js